@file:Suppress("ktlint:standard:backing-property-naming")

package com.nonopn.icons

import androidx.compose.material.icons.Icons
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

public val Icons.Rounded.Density: ImageVector
    get() {
        if (_density != null) {
            return _density!!
        }
        _density =
            Builder(
                name = "Density",
                defaultWidth = 32.0.dp,
                defaultHeight = 32.0.dp,
                viewportWidth = 32.0f,
                viewportHeight = 32.0f,
            )
                .apply {
                    path(
                        fill = SolidColor(Color(0xFF000000)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = NonZero,
                    ) {
                        moveTo(15.0f, 31.36f)
                        horizontalLineToRelative(-3.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-3.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(3.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(3.0f)
                        curveTo(15.36f, 31.199f, 15.199f, 31.36f, 15.0f, 31.36f)
                        close()
                        moveTo(12.36f, 30.64f)
                        horizontalLineToRelative(2.28f)
                        verticalLineToRelative(-2.28f)
                        horizontalLineToRelative(-2.28f)
                        verticalLineTo(30.64f)
                        close()
                        moveTo(30.0f, 30.36f)
                        horizontalLineToRelative(-4.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-4.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(4.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(4.0f)
                        curveTo(30.36f, 30.199f, 30.199f, 30.36f, 30.0f, 30.36f)
                        close()
                        moveTo(26.36f, 29.64f)
                        horizontalLineToRelative(3.279f)
                        verticalLineToRelative(-3.28f)
                        horizontalLineTo(26.36f)
                        verticalLineTo(29.64f)
                        close()
                        moveTo(10.0f, 26.36f)
                        horizontalLineTo(4.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-5.64f)
                        horizontalLineTo(2.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-2.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(2.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(1.64f)
                        horizontalLineTo(10.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(6.0f)
                        curveTo(10.36f, 26.199f, 10.199f, 26.36f, 10.0f, 26.36f)
                        close()
                        moveTo(4.36f, 25.64f)
                        horizontalLineToRelative(5.28f)
                        verticalLineToRelative(-5.28f)
                        horizontalLineTo(4.36f)
                        verticalLineTo(25.64f)
                        close()
                        moveTo(2.36f, 19.64f)
                        horizontalLineToRelative(1.28f)
                        verticalLineToRelative(-1.28f)
                        horizontalLineTo(2.36f)
                        verticalLineTo(19.64f)
                        close()
                        moveTo(24.0f, 25.36f)
                        horizontalLineToRelative(-4.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-4.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(4.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(4.0f)
                        curveTo(24.36f, 25.199f, 24.199f, 25.36f, 24.0f, 25.36f)
                        close()
                        moveTo(20.36f, 24.64f)
                        horizontalLineToRelative(3.279f)
                        verticalLineToRelative(-3.28f)
                        horizontalLineTo(20.36f)
                        verticalLineTo(24.64f)
                        close()
                        moveTo(31.0f, 21.36f)
                        horizontalLineToRelative(-3.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-3.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(3.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(3.0f)
                        curveTo(31.36f, 21.199f, 31.199f, 21.36f, 31.0f, 21.36f)
                        close()
                        moveTo(28.36f, 20.64f)
                        horizontalLineToRelative(2.279f)
                        verticalLineToRelative(-2.28f)
                        horizontalLineTo(28.36f)
                        verticalLineTo(20.64f)
                        close()
                        moveTo(16.0f, 21.36f)
                        horizontalLineToRelative(-2.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-2.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(1.64f)
                        verticalLineTo(16.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(3.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(3.0f)
                        curveToRelative(0.0f, 0.199f, -0.161f, 0.36f, -0.36f, 0.36f)
                        horizontalLineToRelative(-2.64f)
                        verticalLineTo(21.0f)
                        curveTo(16.36f, 21.199f, 16.199f, 21.36f, 16.0f, 21.36f)
                        close()
                        moveTo(14.36f, 20.64f)
                        horizontalLineToRelative(1.28f)
                        verticalLineToRelative(-1.28f)
                        horizontalLineToRelative(-1.28f)
                        verticalLineTo(20.64f)
                        close()
                        moveTo(16.36f, 18.64f)
                        horizontalLineToRelative(2.28f)
                        verticalLineToRelative(-2.28f)
                        horizontalLineToRelative(-2.28f)
                        verticalLineTo(18.64f)
                        close()
                        moveTo(26.0f, 16.36f)
                        horizontalLineToRelative(-2.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-2.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(2.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(2.0f)
                        curveTo(26.36f, 16.199f, 26.199f, 16.36f, 26.0f, 16.36f)
                        close()
                        moveTo(24.36f, 15.64f)
                        horizontalLineToRelative(1.279f)
                        verticalLineToRelative(-1.28f)
                        horizontalLineTo(24.36f)
                        verticalLineTo(15.64f)
                        close()
                        moveTo(7.0f, 16.36f)
                        horizontalLineTo(4.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-2.64f)
                        horizontalLineTo(1.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-3.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(2.64f)
                        verticalLineTo(8.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(2.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(2.0f)
                        curveToRelative(0.0f, 0.199f, -0.161f, 0.36f, -0.36f, 0.36f)
                        horizontalLineTo(4.36f)
                        verticalLineToRelative(2.28f)
                        horizontalLineTo(7.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(3.0f)
                        curveTo(7.36f, 16.199f, 7.199f, 16.36f, 7.0f, 16.36f)
                        close()
                        moveTo(4.36f, 15.64f)
                        horizontalLineToRelative(2.28f)
                        verticalLineToRelative(-2.28f)
                        horizontalLineTo(4.36f)
                        verticalLineTo(15.64f)
                        close()
                        moveTo(1.36f, 12.64f)
                        horizontalLineToRelative(2.28f)
                        verticalLineToRelative(-2.28f)
                        horizontalLineTo(1.36f)
                        verticalLineTo(12.64f)
                        close()
                        moveTo(4.36f, 9.64f)
                        horizontalLineToRelative(1.28f)
                        verticalLineTo(8.36f)
                        horizontalLineTo(4.36f)
                        verticalLineTo(9.64f)
                        close()
                        moveTo(14.0f, 14.36f)
                        horizontalLineToRelative(-2.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineToRelative(-2.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(1.64f)
                        verticalLineTo(6.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(6.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(6.0f)
                        curveToRelative(0.0f, 0.199f, -0.161f, 0.36f, -0.36f, 0.36f)
                        horizontalLineToRelative(-5.64f)
                        verticalLineTo(14.0f)
                        curveTo(14.36f, 14.199f, 14.199f, 14.36f, 14.0f, 14.36f)
                        close()
                        moveTo(12.36f, 13.64f)
                        horizontalLineToRelative(1.28f)
                        verticalLineToRelative(-1.28f)
                        horizontalLineToRelative(-1.28f)
                        verticalLineTo(13.64f)
                        close()
                        moveTo(14.36f, 11.64f)
                        horizontalLineToRelative(5.28f)
                        verticalLineTo(6.36f)
                        horizontalLineToRelative(-5.28f)
                        curveTo(14.36f, 6.36f, 14.36f, 11.64f, 14.36f, 11.64f)
                        close()
                        moveTo(28.0f, 10.36f)
                        horizontalLineToRelative(-3.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineTo(7.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(2.64f)
                        verticalLineTo(5.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(2.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(2.0f)
                        curveToRelative(0.0f, 0.199f, -0.161f, 0.36f, -0.36f, 0.36f)
                        horizontalLineToRelative(-1.64f)
                        verticalLineTo(10.0f)
                        curveTo(28.36f, 10.199f, 28.199f, 10.36f, 28.0f, 10.36f)
                        close()
                        moveTo(25.36f, 9.64f)
                        horizontalLineToRelative(2.279f)
                        verticalLineTo(7.36f)
                        horizontalLineTo(25.36f)
                        verticalLineTo(9.64f)
                        close()
                        moveTo(28.36f, 6.64f)
                        horizontalLineToRelative(1.279f)
                        verticalLineTo(5.36f)
                        horizontalLineTo(28.36f)
                        verticalLineTo(6.64f)
                        close()
                        moveTo(12.0f, 7.36f)
                        horizontalLineTo(8.0f)
                        curveTo(7.801f, 7.36f, 7.64f, 7.199f, 7.64f, 7.0f)
                        verticalLineTo(3.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(4.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(4.0f)
                        curveTo(12.36f, 7.199f, 12.199f, 7.36f, 12.0f, 7.36f)
                        close()
                        moveTo(8.36f, 6.64f)
                        horizontalLineToRelative(3.28f)
                        verticalLineTo(3.36f)
                        horizontalLineTo(8.36f)
                        verticalLineTo(6.64f)
                        close()
                        moveTo(21.0f, 3.36f)
                        horizontalLineToRelative(-2.0f)
                        curveToRelative(-0.199f, 0.0f, -0.36f, -0.161f, -0.36f, -0.36f)
                        verticalLineTo(1.0f)
                        curveToRelative(0.0f, -0.199f, 0.161f, -0.36f, 0.36f, -0.36f)
                        horizontalLineToRelative(2.0f)
                        curveToRelative(0.199f, 0.0f, 0.36f, 0.161f, 0.36f, 0.36f)
                        verticalLineToRelative(2.0f)
                        curveTo(21.36f, 3.199f, 21.199f, 3.36f, 21.0f, 3.36f)
                        close()
                        moveTo(19.36f, 2.64f)
                        horizontalLineToRelative(1.279f)
                        verticalLineTo(1.36f)
                        horizontalLineTo(19.36f)
                        verticalLineTo(2.64f)
                        close()
                    }
                }
                .build()
        return _density!!
    }

private var _density: ImageVector? = null
